import React from 'react';
import { useParams } from 'react-router-dom';
import EntityUserRoleAssignmentsPage from '@features/user/pages/EntityUserRoleAssignmentsPage';

const DistrictUserRoleAssignmentsPage: React.FC = () => {
  const { districtId } = useParams<{ districtId: string }>();
  return (
    <EntityUserRoleAssignmentsPage
      scope="DISTRICT"
      scopeRefId={Number(districtId)}
      title="District - User role assignments"
      subtitle="Role assignments at this district"
      workplaceNoun="district"
      testId="district-user-role-assignments-search"
    />
  );
};

export default DistrictUserRoleAssignmentsPage;
